// Pure formatting helpers shared across Forecast Inputs subcomponents.

import { formatMoney } from "@/components/tekledger-ui";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export function formatPeriod(period: number | null, fy: number | null): string {
  if (period == null || fy == null) return "—";
  return `${MONTHS[period - 1]} ${fy}`;
}

export function formatAmount(amount: number | null): string {
  if (amount === null) return "—";
  if (Math.abs(amount) >= 1_000_000) return `$${(amount / 1_000_000).toFixed(1)}M`;
  if (Math.abs(amount) >= 1_000) return `$${(amount / 1_000).toFixed(0)}K`;
  return formatMoney(amount);
}

export function statusLabel(status: string): string {
  const map: Record<string, string> = {
    open: "Open", active: "Active", approved: "Approved",
    draft: "Draft", retired: "Retired", cancelled: "Cancelled",
    fulfilled: "Fulfilled", inactive: "Inactive",
  };
  return map[status] ?? status;
}

export function statusTone(status: string): string {
  if (["open","active","approved"].includes(status)) return "good";
  if (["retired","cancelled","inactive","fulfilled"].includes(status)) return "bad";
  return "";
}

/** Build a unique economic key from available parts. */
export function economicKey(glAccount: string, vendor: string, fiscalYear: number, suffix: string): string {
  return `${glAccount}-${vendor || "manual"}-${fiscalYear}-${suffix}`;
}
